import { useEffect } from 'react';

type WindowWithClassy = Window & {
  eg?: {
    init: () => void;
    isInitialized: () => boolean;
  };
};

const useGoFundMe = () => {
  useEffect(() => {
    const windowWithClassy = window as WindowWithClassy;
    if (windowWithClassy.eg) {
      windowWithClassy.eg.init();
    }
  }, []);
};

export default useGoFundMe;
